import React from "react";
import { Label } from "../../components/ui/label";
import { Input } from "../../components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../components/ui/select";

export const INPUT_CLS = "bg-[#08080A] border-[#27272A] text-white rounded-sm";

export function Field({ label, children }) {
  return (
    <div>
      <Label className="text-[10px] tracking-[0.25em] uppercase text-[#71717A]">{label}</Label>
      <div className="mt-2">{children}</div>
    </div>
  );
}

export function NumberField({ label, testid, value, onChange, step = "0.01", ...rest }) {
  return (
    <Field label={label}>
      <Input data-testid={testid} type="number" step={step} value={value} onChange={(e) => onChange(e.target.value)} className={`${INPUT_CLS} num`} {...rest} />
    </Field>
  );
}

export function DateField({ label, testid, value, onChange }) {
  return (
    <Field label={label}>
      <Input data-testid={testid} type="date" value={value || ""} onChange={(e) => onChange(e.target.value)} className={INPUT_CLS} />
    </Field>
  );
}

export function SelectRow({ value, onChange, options, testid }) {
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger data-testid={testid} className={INPUT_CLS}>
        <SelectValue />
      </SelectTrigger>
      <SelectContent className="bg-[#121318] border-[#27272A] text-white rounded-sm">
        {options.map((o) => (
          <SelectItem key={o} value={o} className="text-white focus:bg-[#1A1B23]">{o}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
